import React, { useState } from 'react';
import {
  Tabs, TabList, TabPanels, Tab, TabPanel
} from '@chakra-ui/react'
import Otp from './Otp';
import Transactions from './Transactions';
const List = ({ customer_id, channelData }) => {
  const [activeTab, setActiveTab] = useState(0);
  const handleTabChange = (index) => {
    setActiveTab(index);
  };
  return (
    <Tabs className="customer_tabs_section tabs_fit_content" onChange={handleTabChange} index={activeTab}>
      <TabList className="customer_tabs_head_section">
        <Tab>OTP</Tab>
        <Tab>Transactions</Tab>
      </TabList>
      <TabPanels>
        <TabPanel className="analytics_panel_section">
          <Otp customer_id={customer_id} channelData={channelData} message_type_id={1} />
        </TabPanel>
        <TabPanel className="analytics_panel_section">
          <Transactions customer_id={customer_id} message_type_id={2} channelData={channelData} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  )
}
export default List